// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* COLORS */
/* MEASUREMENTS */
.modal-content[data-v-37483b26] {
  width: min(90vw, 600px);
}
.address-group[data-v-37483b26] {
  gap: 1.25em;
}
.address-group .address-options[data-v-37483b26] {
  flex-grow: 1;
  padding: 1em 1em 0.75em;
  border: 1px solid #dee2e6;
}
`, "",{"version":3,"sources":["webpack://./../AddressConfirm.3.vue","webpack://./public/pages/dialogs/AddressConfirm.3.vue"],"names":[],"mappings":"AAAA,WAAW;AACX,iBAAiB;ACCjB;EACI,uBAAA;ADCJ;ACCA;EACI,WAAA;ADCJ;ACFA;EAIQ,YAAA;EACA,uBAAA;EACA,yBAAA;ADCR","sourcesContent":["/* COLORS */\n/* MEASUREMENTS */\n.modal-content {\n  width: min(90vw, 600px);\n}\n.address-group {\n  gap: 1.25em;\n}\n.address-group .address-options {\n  flex-grow: 1;\n  padding: 1em 1em 0.75em;\n  border: 1px solid #dee2e6;\n}\n","\n@import \"/lib/Colors.less\";\n.modal-content {\n    width: min(90vw, 600px);\n}\n.address-group {\n    gap: 1.25em;\n\n    .address-options {\n        flex-grow: 1;\n        padding: 1em 1em 0.75em;\n        border: 1px solid @bs-table-border-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
